/* eslint-disable quotes */
const toastMessages: { [key: string]: string } = {
    imageUploaded: 'Image Uploaded Successfully',
    forgetPwd: 'Mail Sent Successfully',
    pwdChanged: 'Password Changed Successfully',
    otpSent: 'OTP sent to your registered email address',
    bookingSubmitted: 'Booking Submitted Successfully',
    bookingActivated: 'Booking Activated Succcessfully',
    bookingInActivated: 'Booking In-Activated Successfully',

    // User
    userAdded: 'User Added Successfully',
    userUpdated: 'User Updated Successfully',
    pilotActivated: 'Pilot Activated Successfully',
    pilotInActivated: 'Pilot In-Activated Successfuly',
    userInActivated: 'user In-Activated Successfully',
    userActivated: 'user Activated Successfully',

    //New Request
    newUserRequestApproved: 'User Created Succussfully',
    newUserRequestRejected: 'User Rejected Successfully',
    newUserDelete: 'Request Deleted Successfully',

    // Login
    login: 'User Logged In Successfully',
    logout: 'User Logged Out Successfully',

    //ADD AREAS
    areaAdded: 'Area Saved Successfully',
    areaUpdate: 'Area Updated Successfully',
    areaDelete: 'Area Deleted Successfully',

    //ADD MINES
    mineAdded: 'Mine Saved Successfully',
    mineUpdate: 'Mine Updated Successfully',
    mineDelete: 'Mine Deleted Successfully',

    //Nodal officer mines
    mineAddedNO: 'Mine Request Saved Successfully',
    mineUpdateNO: 'Mine Request Updated Successfully',
    mineDeleteNO: 'Mine Request Deleted Successfully',

    // Sources
    sourceAdded: 'Source Saved Successfully ',
    sourceUpdated: 'Source Updated Successfully',
    sourceDelete: 'Source Deleted Successfully',
    source3DAdded: '3D Layer Saved Successfully',
    source3DUpdate: '3D Layer Updated Successfully',
    source3D: '3D Layer Deleted Successfully',

    //upload
    excelUploaded: 'File Uploaded Successfully',

    //Report
    addedReport: 'Report Saved Successfully',
    updatedReport: 'Report Updated Successfully',
    deletedReport: 'Report Deleted Successfully',

    // Download
    addedDownload: 'Record Saved Successfully',
    updatedDownload: 'Record Updated Successfully',
    deletedDownload: 'Record Deleted Successfully',

    //Add mines validation
    maxminMisMatch: 'Max ZooM Level Cannot be less than Min Zoom Level',
    zoomGreaterThanMax: 'Zoom Level Cannot be more than Max Zoom Level',
    zoomLessThanMin: 'Zoom Level Cannot be less than Min Zoom Level',

    // Information Management
    approve: 'Approved Successfully',
    reject: 'Rejected Successfully',

    // Draw Tools
    featureAdded: 'Feature Saved Successfully.',
    featureUpdated: 'Feature Updated Successfully.',
    bufferAdded: 'Buffer Saved Successfully.',
    bufferUpdated: 'Buffer Updated Successfully.',

    //EmployeeID
    addedEmployeeID:'Employee ID added successfully',
    updatedEmployeeID:'Employee ID modified successfully',
    deletedEmployeeID:'Employee ID deleted successfully',
    //Profile Images
    errorInDeletion: 'Unable to upload Profile Picture at this time'
};

export default toastMessages;
